import {endOfYear, startOfYear, format} from 'date-fns'
import {getPersistedRangeOr} from '@/dateUtils/dateRange.service'

export interface TransactionSearchParams {
    query?: string,
    subAccountUuid?: string,
    accountNo?: string,
    fromAccountNo?: string,
    toAccountNo?: string,
    page?: number
    fromDate?: string,
    toDate?: string,
    invoiceUuid?: string,
    department?: string,
    project?: string,
    isDeleted?: boolean
}

export const defaultSearchParams = (isDeleted?: boolean): TransactionSearchParams => {
    const now = new Date()
    const range = getPersistedRangeOr({
        start: startOfYear(now),
        end: endOfYear(now)
    })
    return {
        fromDate:  format(range.start, 'yyyy-MM-dd'),
        toDate: format(range.end, 'yyyy-MM-dd'),
        page: 0,
        isDeleted: isDeleted
    }
}